
(function (angular) {

	angular.module('app.core', [
		'slider',
	])

		.config(function () {
		})

	;

})(angular);
